export const aboutData = {
    title: "Who I am",
    description1: "My name is Subham Guota. I'm a Frontend Web Developer from Siliguri, West Bengal.",
    description2: "I am a passionate and hardworking engineering undergraduate seeking opportunities and exposure to learn, grow, develop and improve my programming and development knowledge, leadership skills and technical abilities.",
    image: 1
}
